(() => {
  const namespaceKey = 'GuruShopHeaderHeightTracker';
  const sourceScript = document.currentScript;
  const requestedRootId = sourceScript?.dataset.headerHeightRoot;
  const existingApi = window[namespaceKey];

  if (existingApi) {
    existingApi.initById(requestedRootId);
    return;
  }

  const initializedRoots = new WeakSet();
  const cleanupByRoot = new WeakMap();

  const initRoot = (sectionRoot) => {
    if (
      !(sectionRoot instanceof HTMLElement)
      || initializedRoots.has(sectionRoot)
      || sectionRoot.dataset.heightBound === 'true'
    ) {
      return false;
    }

    const header = sectionRoot.querySelector('.header');

    if (!header) {
      return false;
    }

    const syncHeaderHeight = () => {
      document.documentElement.style.setProperty(
        '--header-height',
        `${sectionRoot.clientHeight.toFixed(2)}px`,
      );
    };

    let resizeObserver = null;

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(syncHeaderHeight);
      resizeObserver.observe(sectionRoot);
      sectionRoot.headerResizeObserver = resizeObserver;
    }

    const classObserver = new MutationObserver(syncHeaderHeight);
    classObserver.observe(header, {
      attributes: true,
      attributeFilter: ['class'],
    });
    sectionRoot.headerClassObserver = classObserver;

    window.addEventListener('resize', syncHeaderHeight, { passive: true });

    sectionRoot.dataset.heightBound = 'true';
    initializedRoots.add(sectionRoot);
    cleanupByRoot.set(sectionRoot, () => {
      resizeObserver?.disconnect();
      classObserver.disconnect();
      window.removeEventListener('resize', syncHeaderHeight);

      if (sectionRoot.headerResizeObserver === resizeObserver) {
        delete sectionRoot.headerResizeObserver;
      }

      if (sectionRoot.headerClassObserver === classObserver) {
        delete sectionRoot.headerClassObserver;
      }

      delete sectionRoot.dataset.heightBound;
    });

    syncHeaderHeight();
    return true;
  };

  const initById = (rootId) => {
    if (!rootId) return false;
    return initRoot(document.getElementById(rootId));
  };

  const cleanupRoot = (sectionRoot) => {
    if (!(sectionRoot instanceof HTMLElement) || !initializedRoots.has(sectionRoot)) return false;

    cleanupByRoot.get(sectionRoot)?.();
    cleanupByRoot.delete(sectionRoot);
    initializedRoots.delete(sectionRoot);
    return true;
  };

  const initWithin = (scope) => {
    if (!(scope instanceof Element || scope instanceof Document)) return;

    const markerSelector = 'script[data-header-height-root]';

    if (scope.matches?.(markerSelector)) {
      initById(scope.dataset.headerHeightRoot);
    }

    scope.querySelectorAll(markerSelector).forEach((marker) => {
      initById(marker.dataset.headerHeightRoot);
    });
  };

  window[namespaceKey] = { initById, initWithin, cleanupRoot };

  document.addEventListener('shopify:section:load', (event) => {
    initWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    cleanupRoot(event.target);
  });

  initById(requestedRootId);
})();
